export default __webpack_public_path__ + "static/media/questsSelected.633162e2.svg";